/* StreetHolo — global.js
   Minimal, dependency-free. Event delegation so re-rendered sections keep working. */
(function () {
  'use strict';

  /* ---------- Utilities ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    format = format || window.moneyFormat || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (format.match(placeholderRegex) && format.match(placeholderRegex)[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function trapFocusable(container) {
    var el = container.querySelector('button, a, input, [tabindex]');
    if (el) el.focus();
  }

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawers (menu + cart) ---------- */
  function openDrawer(sel) {
    var d = document.querySelector(sel);
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    trapFocusable(d);
  }
  function closeDrawers() {
    document.querySelectorAll('.menu-drawer.is-open, .cart-drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-open-menu]'))) { e.preventDefault(); openDrawer('.menu-drawer'); }
    if ((t = e.target.closest('[data-open-cart]'))) {
      var drawer = document.querySelector('.cart-drawer');
      if (drawer) { e.preventDefault(); openDrawer('.cart-drawer'); }
    }
    if (e.target.closest('[data-close-drawer]') || e.target.classList.contains('menu-drawer__overlay') || e.target.classList.contains('cart-drawer__overlay')) {
      e.preventDefault();
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Cart ---------- */
  function refreshCartDrawer(openAfter) {
    var section = document.getElementById('shopify-section-cart-drawer');
    if (!section) return Promise.resolve();
    return fetch(window.routes.root_url + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        tmp.innerHTML = data['cart-drawer'];
        var fresh = tmp.querySelector('.cart-drawer');
        var current = section.querySelector('.cart-drawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.replaceWith(fresh);
          if (wasOpen || openAfter) {
            fresh.classList.add('is-open');
            fresh.setAttribute('aria-hidden', 'false');
            document.documentElement.style.overflow = 'hidden';
          }
          var count = fresh.getAttribute('data-item-count') || '0';
          document.querySelectorAll('[data-cart-count]').forEach(function (b) {
            b.textContent = count;
            b.setAttribute('data-count', count);
          });
        }
      });
  }

  function addToCart(body) {
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: body
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }

  // Product form submit
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-atc-button]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = btn.getAttribute('data-adding-text') || 'Adding…'; }
    addToCart(new FormData(form))
      .then(function () { return refreshCartDrawer(true); })
      .catch(function (err) {
        alert((err && err.description) || 'Could not add to cart.');
      })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.textContent = original; }
      });
  });

  // Upsell / quick add buttons
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-variant]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-disabled', 'true');
    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-add-variant'));
    fd.append('quantity', '1');
    addToCart(fd)
      .then(function () { return refreshCartDrawer(true); })
      .catch(function () {})
      .finally(function () { btn.removeAttribute('aria-disabled'); });
  });

  // Cart line quantity change / remove
  function changeLine(line, quantity) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function () { return refreshCartDrawer(false); });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var remove = e.target.closest('[data-remove-line]');
    if (remove) {
      e.preventDefault();
      changeLine(parseInt(remove.getAttribute('data-remove-line'), 10), 0).then(maybeReloadCartPage);
      return;
    }
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.qty-input');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var val = parseInt(input.value, 10) || 1;
    val = plus ? val + 1 : Math.max(minus.hasAttribute('data-line') || wrap.hasAttribute('data-line') ? 0 : 1, val - 1);
    input.value = Math.max(val, wrap.hasAttribute('data-line') ? 0 : 1);
    var line = wrap.getAttribute('data-line');
    if (line) {
      changeLine(parseInt(line, 10), parseInt(input.value, 10)).then(maybeReloadCartPage);
    }
  });

  function maybeReloadCartPage() {
    if (document.body.classList.contains('template-cart')) window.location.reload();
  }

  /* ---------- Product gallery (swipeable scroll-snap track) ---------- */

  // Thumbnail click → scroll the track to that slide
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-target]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-media-track]');
    if (!track) return;
    var id = thumb.getAttribute('data-media-target');
    var items = Array.prototype.slice.call(track.querySelectorAll('[data-media-item]'));
    var index = items.findIndex(function (m) { return m.getAttribute('data-media-item') === id; });
    if (index < 0) return;
    track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
  });

  // Scroll → sync active thumbnail, pause off-screen videos
  function initGalleryTracks() {
    document.querySelectorAll('[data-media-track]').forEach(function (track) {
      if (track.__shInit) return;
      track.__shInit = true;
      var gallery = track.closest('[data-product-gallery]');
      var ticking = false;

      function sync() {
        ticking = false;
        var w = track.clientWidth;
        if (!w) return;
        var index = Math.round(track.scrollLeft / w);
        var items = track.querySelectorAll('[data-media-item]');
        items.forEach(function (m, i) {
          var active = i === index;
          m.classList.toggle('is-active', active);
          var vid = m.querySelector('video');
          if (vid && !active && !vid.paused) vid.pause();
        });
        if (gallery) {
          var thumbs = gallery.querySelectorAll('[data-media-target]');
          thumbs.forEach(function (t, i) {
            var active = i === index;
            t.classList.toggle('is-active', active);
            if (active && t.scrollIntoView) {
              t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
          });
        }
      }

      track.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(sync); }
      }, { passive: true });

      // Keyboard support when the track is focused
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var w = track.clientWidth;
        var index = Math.round(track.scrollLeft / w) + (e.key === 'ArrowRight' ? 1 : -1);
        track.scrollTo({ left: index * w, behavior: 'smooth' });
      });
    });
  }
  initGalleryTracks();
  document.addEventListener('shopify:section:load', initGalleryTracks);

  /* ---------- Product image zoom (tap to open, pinch / double-tap to zoom) ---------- */
  var zoomModal = null;

  function buildZoomModal() {
    if (zoomModal) return zoomModal;
    var modal = document.createElement('div');
    modal.className = 'zoom-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Image zoom');
    modal.innerHTML =
      '<div class="zoom-modal__stage" data-zoom-stage>' +
        '<img class="zoom-modal__img" data-zoom-img alt="">' +
      '</div>' +
      '<button type="button" class="zoom-modal__close" data-zoom-close aria-label="Close zoom">&times;</button>' +
      '<span class="zoom-modal__hint">Pinch or double-tap to zoom</span>';
    document.body.appendChild(modal);

    var stage = modal.querySelector('[data-zoom-stage]');
    var img = modal.querySelector('[data-zoom-img]');

    // Transform state
    var scale = 1, tx = 0, ty = 0;
    var MIN_SCALE = 1, MAX_SCALE = 4;

    function apply() {
      img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    }

    function clampPan() {
      var w = stage.clientWidth, h = stage.clientHeight;
      var maxX = Math.max(0, (w * scale - w));
      var maxY = Math.max(0, (h * scale - h));
      tx = Math.min(0, Math.max(-maxX, tx));
      ty = Math.min(0, Math.max(-maxY, ty));
    }

    function reset() { scale = 1; tx = 0; ty = 0; apply(); }

    function zoomAt(x, y, targetScale) {
      var prev = scale;
      scale = Math.min(MAX_SCALE, Math.max(MIN_SCALE, targetScale));
      // Keep the point under the cursor/finger fixed while scaling
      tx = x - (x - tx) * (scale / prev);
      ty = y - (y - ty) * (scale / prev);
      if (scale === 1) { tx = 0; ty = 0; }
      clampPan();
      apply();
    }

    // Pointer handling: 1 pointer = pan (when zoomed), 2 pointers = pinch
    var pointers = new Map();
    var pinchStartDist = 0, pinchStartScale = 1;
    var lastTap = 0, lastTapX = 0, lastTapY = 0;
    var singleTapTimer = null;
    var moved = false;

    function dist(a, b) {
      var dx = a.x - b.x, dy = a.y - b.y;
      return Math.sqrt(dx * dx + dy * dy);
    }
    function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    function pts() { return Array.from(pointers.values()); }

    stage.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      stage.setPointerCapture(e.pointerId);
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      moved = false;
      if (pointers.size === 2) {
        var p = pts();
        pinchStartDist = dist(p[0], p[1]);
        pinchStartScale = scale;
        if (singleTapTimer) { clearTimeout(singleTapTimer); singleTapTimer = null; }
      }
    });

    stage.addEventListener('pointermove', function (e) {
      if (!pointers.has(e.pointerId)) return;
      var prevPt = pointers.get(e.pointerId);
      var dx = e.clientX - prevPt.x, dy = e.clientY - prevPt.y;
      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) moved = true;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pointers.size === 2 && pinchStartDist > 0) {
        var p = pts();
        var d = dist(p[0], p[1]);
        var m = mid(p[0], p[1]);
        zoomAt(m.x, m.y, pinchStartScale * (d / pinchStartDist));
      } else if (pointers.size === 1 && scale > 1) {
        tx += dx; ty += dy;
        clampPan();
        apply();
      }
    });

    function endPointer(e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinchStartDist = 0;

      if (e.type === 'pointerup' && pointers.size === 0 && !moved) {
        var now = Date.now();
        var isDoubleTap = (now - lastTap) < 300 &&
          Math.abs(e.clientX - lastTapX) < 40 && Math.abs(e.clientY - lastTapY) < 40;
        if (isDoubleTap) {
          lastTap = 0;
          if (singleTapTimer) { clearTimeout(singleTapTimer); singleTapTimer = null; }
          zoomAt(e.clientX, e.clientY, scale > 1 ? 1 : 2.5);
        } else {
          lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
          if (scale === 1) {
            // Single tap while not zoomed closes — but wait to rule out a double-tap
            singleTapTimer = setTimeout(function () {
              singleTapTimer = null;
              closeZoom();
            }, 300);
          }
        }
      }
    }
    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    // Desktop: scroll wheel zoom + double-click handled by the tap logic above
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var factor = e.deltaY < 0 ? 1.15 : 0.87;
      zoomAt(e.clientX, e.clientY, scale * factor);
    }, { passive: false });

    modal.querySelector('[data-zoom-close]').addEventListener('click', closeZoom);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeZoom();
    });

    function closeZoom() {
      modal.classList.remove('is-open');
      document.body.classList.remove('zoom-modal-open');
      pointers.clear();
      reset();
      img.removeAttribute('src');
    }

    zoomModal = {
      open: function (src, alt) {
        reset();
        img.src = src;
        img.alt = alt || '';
        modal.classList.add('is-open');
        document.body.classList.add('zoom-modal-open');
      }
    };
    return zoomModal;
  }

  document.addEventListener('click', function (e) {
    var zoomImg = e.target.closest('[data-product-gallery] .product__media-item img');
    if (!zoomImg) return;
    e.preventDefault();
    var src = zoomImg.getAttribute('data-zoom-src') || zoomImg.currentSrc || zoomImg.src;
    buildZoomModal().open(src, zoomImg.alt);
  });

  /* ---------- Variant picker ---------- */
  document.addEventListener('change', function (e) {
    var picker = e.target.closest('[data-variant-picker]');
    if (!picker) return;
    var wrap = picker.closest('[data-product-info]');
    if (!wrap) return;
    var jsonEl = wrap.querySelector('[data-variant-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);

    var selected = [];
    wrap.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var checked = group.querySelector('input:checked');
      var select = group.querySelector('select');
      selected[idx] = checked ? checked.value : (select ? select.value : null);
    });

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });

    var idInput = wrap.querySelector('input[name="id"]');
    var atc = wrap.querySelector('[data-atc-button]');
    var priceEl = wrap.querySelector('[data-price-current]');
    var compareEl = wrap.querySelector('[data-price-compare]');
    var badgeEl = wrap.querySelector('[data-price-badge]');

    if (!match) {
      if (atc) { atc.setAttribute('aria-disabled', 'true'); atc.textContent = atc.getAttribute('data-unavailable-text') || 'Unavailable'; }
      return;
    }
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.hidden = false;
        if (badgeEl) {
          var pct = Math.round((match.compare_at_price - match.price) / match.compare_at_price * 100);
          badgeEl.textContent = (badgeEl.getAttribute('data-prefix') || 'Save') + ' ' + pct + '%';
          badgeEl.hidden = false;
        }
      } else {
        compareEl.hidden = true;
        if (badgeEl) badgeEl.hidden = true;
      }
    }
    if (atc) {
      if (match.available) {
        atc.removeAttribute('aria-disabled');
        atc.textContent = atc.getAttribute('data-atc-text') || 'Add to cart';
      } else {
        atc.setAttribute('aria-disabled', 'true');
        atc.textContent = atc.getAttribute('data-soldout-text') || 'Sold out';
      }
    }
    if (window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
  });

  /* ---------- Sticky add-to-cart ---------- */
  var stickyBar = document.querySelector('.sticky-atc');
  var buyAnchor = document.querySelector('[data-buy-anchor]');
  if (stickyBar && buyAnchor && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(buyAnchor);
  }
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-scroll-to-buy]');
    if (jump && buyAnchor) {
      e.preventDefault();
      buyAnchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  /* ---------- Deferred video (demo section) ---------- */
  document.addEventListener('click', function (e) {
    var play = e.target.closest('[data-video-play]');
    if (!play) return;
    e.preventDefault();
    var frame = play.closest('.video-frame');
    if (!frame) return;
    var video = frame.querySelector('video');
    var iframe = frame.querySelector('iframe[data-src]');
    if (video) { video.setAttribute('controls', ''); video.play(); }
    if (iframe) iframe.src = iframe.getAttribute('data-src');
    play.remove();
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var revealIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealIo.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { revealIo.observe(el); });
  }

  /* ---------- Recently viewed ---------- */
  var RV_KEY = 'sh_recently_viewed';
  var productMeta = document.querySelector('[data-product-handle]');
  try {
    if (productMeta) {
      var handle = productMeta.getAttribute('data-product-handle');
      var list = JSON.parse(localStorage.getItem(RV_KEY) || '[]').filter(function (h) { return h !== handle; });
      list.unshift(handle);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8)));
    }
    var rvContainer = document.querySelector('[data-recently-viewed]');
    if (rvContainer) {
      var currentHandle = productMeta ? productMeta.getAttribute('data-product-handle') : null;
      var handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]')
        .filter(function (h) { return h !== currentHandle; })
        .slice(0, parseInt(rvContainer.getAttribute('data-limit') || '4', 10));
      if (!handles.length) {
        var sectionEl = rvContainer.closest('.shopify-section');
        if (sectionEl) sectionEl.style.display = 'none';
      } else {
        Promise.all(handles.map(function (h) {
          return fetch(window.routes.root_url + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; });
        })).then(function (products) {
          products.filter(Boolean).forEach(function (p) {
            var card = document.createElement('div');
            card.className = 'product-card';
            var img = p.featured_image ? '<img src="' + p.featured_image + '&width=600" onerror="this.src=\'' + p.featured_image + '\'" alt="" loading="lazy">' : '';
            card.innerHTML =
              '<a class="product-card__link" href="' + p.url + '">' +
                '<div class="product-card__media">' + img + '</div>' +
                '<div class="product-card__info"><h3 class="product-card__title">' + p.title + '</h3>' +
                '<div class="price"><span class="price__current">' + formatMoney(p.price) + '</span>' +
                (p.compare_at_price > p.price ? '<s class="price__compare">' + formatMoney(p.compare_at_price) + '</s>' : '') +
                '</div></div></a>';
            rvContainer.appendChild(card);
          });
        });
      }
    }
  } catch (err) { /* localStorage unavailable — fail silently */ }

  /* ---------- Judge.me rating text on product cards (4.80 -> 4.8) ---------- */
  document.querySelectorAll('.product-card__rating .jdgm-prev-badge[data-average-rating]').forEach(function (b) {
    var avg = parseFloat(b.getAttribute('data-average-rating'));
    if (!isNaN(avg)) b.setAttribute('data-average-rating', String(Math.round(avg * 10) / 10));
  });

  window.SH = { formatMoney: formatMoney, refreshCartDrawer: refreshCartDrawer };
})();
